export function contactMatchesSearch(
  haystackParts: Array<string | null | undefined>,
  query: string
): boolean {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return true;
  }
  const haystack = haystackParts
    .filter((part): part is string => Boolean(part))
    .join(' ')
    .toLowerCase();
  return haystack.includes(normalized);
}
